import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { RootState } from '../../../../configuration/setup/store';
import { freeTrialTabActions, getAssetSearch } from './redux/freeTrialTab.redux';

interface Props {
    searchValue: string;
    onSearchChange: (searchValue: string) => void;
}

const FreeTrialTableSearch = (props: Props) => {
    const { searchValue, onSearchChange } = props;
    const intl = useIntl();

    return (
        <TableSearch
            placeholder={intl.formatMessage({ id: 'intl-msg:marketplace.usage.summary.search.placeholder' })}
            value={searchValue}
            onChange={onSearchChange}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    searchValue: getAssetSearch(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSearchChange: (searchValue: string) => dispatch(freeTrialTabActions.setAssetSearch(searchValue)),
});

export const FreeTrialTableSearchContainer = connect(mapStateToProps, mapDispatchToProps)(FreeTrialTableSearch);
